import { HgSupportedLanguage } from '@smg-real-estate/domus';

export const listingPreviewRoutes = () =>
  [
    HgSupportedLanguage.DE,
    HgSupportedLanguage.EN,
    HgSupportedLanguage.FR,
    HgSupportedLanguage.IT,
  ].map((locale) => ({
    path: `/${locale}/preview`,
    component: () => import('@/views/ListingPreviewPage/ListingPreviewPage.vue'),
    name: `listingPreviewPage-${locale}`,
    meta: {
      locale,
      viewName: 'Listing Preview Page',
      getLanguageSwitchLink(route: any, locale: HgSupportedLanguage) {
        return {
          name: `listingPreviewPage-${locale}`,
          query: route.query,
          params: route.params,
        };
      },
    },
  }));
